import React from 'react';
import styled from 'styled-components';

const ProcessWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 2rem;
  @media screen and (max-width: 600px) {
    margin-top: 13px;
    margin-bottom: 1rem;
  }
`;

const Step = styled.div<StepProps>`
  background: ${({ active, allDone }) => (allDone ? '#80e0a6' : active ? '#80e0a6' : '#e2e2e2')};
  width: 2rem;
  height: 2rem;
  border-radius: 1rem;
  color: #000;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
  z-index: 2;
  transition: all 0.2s ease;
  font-size: 14px;
  border: ${({ current }) => (current ? '2px solid #fff' : '0')};
  box-shadow: ${({ current, allDone }) =>
    allDone ? '0 0 0 1px #80e0a6' : current ? `0 0 0 1px #80e0a6` : 'none'};
`;

const PercentLine = styled.div<LineProps>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 1px;
  background: #d0d0d0;
  z-index: 1;
  > span {
    position: absolute;
    background: #80e0a6;
    left: 0;
    top: 0;
    height: 100%;
    width: ${({ widthPercent }) => `${widthPercent}%`};
    transition: all 0.2s ease;
    &:after {
      content: '';
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 0.2rem;
      background: #80e0a6;
      position: absolute;
      left: 100%;
      top: 50%;
      transform: translateY(-50%);
      transition: all 0.2s ease;
    }
  }
`;

interface Props {
  steps: number;
  activeStep: number;
  percentLine: number;
  allDone: boolean;
}

interface StepProps {
  active: boolean;
  allDone: boolean;
  current: boolean;
}

interface LineProps {
  widthPercent: number;
  allDone: boolean;
}

export const Process: React.FC<Props> = ({ steps, activeStep, percentLine, allDone }) => {
  const stpArr = [...Array(steps).keys()].map((i) => i + 1);
  // const percent = ((activeStep - 1) / steps) * 100;
  return (
    <ProcessWrapper>
      <PercentLine allDone={allDone} widthPercent={percentLine}>
        <span />
      </PercentLine>
      {stpArr.map((i) => (
        <Step key={i} current={i === activeStep} active={activeStep >= i} allDone={allDone}>
          {i}
        </Step>
      ))}
    </ProcessWrapper>
  );
};
